import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ButtonIcon, Checkbox } from '@morressier/alembic';
import { FormFieldCheckbox as IFormFieldCheckbox } from '@publishing-engine/domain/types/article';
import { Flex, Text } from '@chakra-ui/react';
import { parseStringWithLinks } from 'src/utils/parseStringWithLinks';
import { FieldLabel } from 'src/components/Field';
import FormFieldErrorMessage from './common/FormFieldErrorMessage';
import { Tooltip } from '@chakra-ui/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

interface IFormFieldCheckboxProps {
  config: IFormFieldCheckbox;
  isEditingAllowed?: boolean;
}

const FormFieldCheckbox: React.FC<IFormFieldCheckboxProps> = ({
  config,
  isEditingAllowed = true
}) => {
  const { register } = useFormContext();

  const {
    name,
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
      <FieldLabel
        isRequired={validations.required}
        label={labels.main}
        subText={labels.subtitle}
        helpText={labels.helpText}
      />
      <Flex>
        <Checkbox
          ariaLabel={labels.main}
          id={name}
          {...register(field, { required: validations.required })}
          isDisabled={!isEditingAllowed}
        >
          {parseStringWithLinks(
            labels.content || labels.subtitle,
            name === 'SubmissionGuidelines' ? 'private' : undefined
          )}
        </Checkbox>
        {labels.helpText && (
          <Tooltip
            hasArrow
            shouldWrapChildren
            placement="top"
            label={
              <Text textStyle="textContext">
                {typeof labels.helpText === 'string'
                  ? parseStringWithLinks(
                      labels.helpText,
                      name === 'SubmissionGuidelines' ? 'private' : undefined
                    )
                  : labels.helpText}
              </Text>
            }
            borderRadius={4}
            data-cy="info-tooltip"
          >
            <ButtonIcon
              size="small"
              ariaLabel="Back to workspace settings"
              icon={<FontAwesomeIcon icon={faInfoCircle} />}
              data-cy="info-icon"
              ml={1}
            />
          </Tooltip>
        )}
      </Flex>
      <FormFieldErrorMessage config={config} />
    </Flex>
  );
};

export default FormFieldCheckbox;
